import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { SearchMaterials } from "contexts/search/context";
import { useTenantTranslation } from "hooks/formatters";
import { useHandleTableMutations } from "./useHandleTableMutations";

interface Props {
  materials: SearchMaterials;
  selectedItemIds: string[];
  setSelectedItemIds: (selectedItemsIds: string[]) => void;
}

export const DeleteAvailabilitiesButton = ({
  materials,
  selectedItemIds,
  setSelectedItemIds,
}: Props) => {
  const { t } = useTenantTranslation();
  const { handleRemoveItems } = useHandleTableMutations(materials);

  return (
    <Button
      color="secondary"
      onClick={() => {
        handleRemoveItems(selectedItemIds);
        setSelectedItemIds([]);
      }}
      startIcon={<DeleteIcon />}
    >
      {t("deleteSelectedRows")} ({selectedItemIds.length})
    </Button>
  );
};
